import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store';
import { ShellBridgeEvents } from 'app/shared/constants/constants';
import { publishShellEvent } from 'utilities/publishBridgeEvent';
import useMobileTopBar from 'hooks/useMobileTopBar';
import ConfirmationModal from './ConfirmationModal';

// The native shell owns restarting the guest session; do not run browser logout here.
const ShellGuestSessionExpiredModal: React.FC = () => {
    const { isGuest, logoutRequested } = useSelector((state: RootState) => state.auth);
    const isSessionExpired = isGuest && logoutRequested;

    useMobileTopBar({
        title: 'Session expired',
        showBackButton: false,
        isSkipUpdate: !isSessionExpired,
    });

    if (!isSessionExpired) return null;

    return (
        <ConfirmationModal
            showModal
            modalHeaderText="Session expired"
            messageText="Your session has expired. Please restart your order."
            submitBtnText="Restart order"
            handleSuccessAction={() => {
                // Initiate navigation, rather than acknowledge a native toolbar request.
                publishShellEvent(ShellBridgeEvents.MOBILE_ORDERCON_POPHOME);
            }}
        />
    );
};

export default ShellGuestSessionExpiredModal;
